<template>
  <div class="row mt-2 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 gap-4">
    <div class="">
      <span class="my-0 h3 text-uppercase  h5 border-gray sm:block hidden">{{
          $t('footer.menu_titles.dda')
        }}</span>
      <span class="my-0 h3 text-uppercase  h5 sm:hidden block hoverable-menu border-gray" id="dda-menu" @click="show('dda')">{{
          $t('footer.menu_titles.dda')
        }}</span>
      <ul class="p-0  mt-2  h7 submenu" id="dda">
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <inertia-link class="my-0 text-sm" :href="route('shop.landing')"
                        :data="{ anchor: 'how-to' }">{{ $t('footer.about_us') }}
          </inertia-link>
        </li>

        <li class="  text-hoverable list-unstyled py-0 my-0">
          <inertia-link class="my-0 text-sm" :href="route('shop.landing')"
                        :data="{ anchor: 'contact' }">{{ $t('footer.contact') }}
          </inertia-link>
        </li>
      </ul>
    </div>
    <div class="">
      <span class="my-0 r-text-small  h3 text-uppercase  h5 block d-block" id="services-menu">{{ $t('footer.menu_titles.services') }}</span>
      <ul class="p-0  mt-2  h7 " id="services">
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <a class="my-0 text-sm" :href="route('shop.howbuy.view')"> {{
              $t('footer.how_buy')
            }}</a>
        </li>
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <a class="my-0 text-sm" :href="route('shop.howsell.view')">{{
              $t('footer.how_sell')
            }}</a>
        </li>
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <a class="my-0 text-sm" :href="route('consignment-rules')">{{
              $t('footer.consignment_rules')
            }}</a>
        </li>
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <a class="my-0 text-sm" :href="route('shop.howbuyrules.view')">{{
              $t('footer.how_buy_rules')
            }}</a>
        </li>
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <a class="my-0 text-sm"
             :href="route('gift-certificate')">{{ $t('footer.gift_certificate') }}</a>
        </li>
      </ul>
    </div>
    <div class="">
      <span class="my-0 r-text-small  h3 text-uppercase  h5 sm:block hidden">{{ $t('footer.menu_titles.categories') }}</span>
      <span class="my-0 r-text-small  h3 text-uppercase  h5 sm:hidden block hoverable-menu" id="categories-menu" @click="show('categories')">{{ $t('footer.menu_titles.categories') }}</span>
      <ul class="p-0  mt-2  h7 submenu" id="categories">
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <a class="my-0 text-sm" :href="route('shop.category.view', 'gifts')">
            {{ $t('footer.gifts') }}</a>
        </li>
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <a class="my-0 text-sm"
             :href="route('shop.category.view', 'bijuterie-ceasuri')">{{ $t('footer.jewelry_watches') }}</a>
        </li>
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <a class="my-0 text-sm"
             :href="route('shop.category.view', 'pictura-sculptura-gravura')">{{ $t('footer.painting_sculpture') }}</a>
        </li>
      </ul>
    </div>
    <div class="">
      <span class="my-0 r-text-small  h3 text-uppercase  h5 sm:block hidden">{{$t('footer.menu_titles.account')}}</span>
      <span class="my-0 r-text-small  h3 text-uppercase  h5 sm:hidden block hoverable-menu" id="login-menu" @click="show('login')">{{
          $t('footer.menu_titles.account')
        }}</span>
      <ul class="p-0  mt-2  h7 submenu" id="login">
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <inertia-link class="my-0 text-sm"
                        :href="route('shop.login')">
            {{ $t('footer.login') }}
          </inertia-link>
        </li>
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <inertia-link class="my-0 text-sm" :href="route('shop.register')">{{$t('footer.register')}}
          </inertia-link>
        </li>
        <li class="  text-hoverable list-unstyled py-0 my-0">
          <inertia-link class="my-0 text-sm" :href="route('shop.cart.view')">{{$t('footer.cart')}}
          </inertia-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped>
@media (max-width: 768px) {
  ul.submenu {
    display: none;
  }
}
</style>
<script>
export default {
  name: "FooterMenu",
  methods: {
    show: function (param) {
      document.querySelectorAll('.hoverable-menu-active').forEach(item => item.classList.remove('hoverable-menu-active'))
      const list = document.getElementById(param);
      const menu = document.getElementById(param + '-menu');
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        if (list.style.display == "none") {
          menu.classList.add('hoverable-menu-active');
          list.style.display = "block";
        } else {
          list.style.display = "none";
        }
      }
    }
  },
}
</script>